import { errorBoundary } from '../dependencies';

import ErrorMessage from '../containers/ErrorMessage';

export default errorBoundary(ErrorMessage);
